import dayjs from 'dayjs';
import printJS from 'print-js';
import pdfMake from 'pdfmake/build/pdfmake.js';

import { vfs } from 'documents/vfs';
import { MARK_WORDS } from 'documents/constants';
import { centimetersToPoints } from 'documents/constants';

export const appendixMiddle = (parameters, student, program) => {
	// Award and attendace achievements
	const award = student.awards.find(a => a.type === 'award');
	const attendance = student.awards.find(a => a.type === 'attendance');
	const released = student.finals.find(f => f.released);
	const finals = student.finals.filter(f => !f.released);

	const document = {
		pageOrientation: 'portrait',
		pageSize: 'A4',
		pageMargins: [centimetersToPoints(2), centimetersToPoints(2), centimetersToPoints(2), centimetersToPoints(2)],
		defaultStyle: {
	    lineHeight: 1,
			fontSize: 12,
			font: 'Times'
		},
		content: [
			{
				margin: [0, centimetersToPoints(2.2), 0, 0],
				columns: [
					{
						width: centimetersToPoints(8.2),
						text: '',
					},
					{
						width: centimetersToPoints(1),
						text: student.certificate.series,
						alignment: 'center',
						fontSize: 14,
						bold: true
					},
					{
						width: centimetersToPoints(1),
						text: '',
					},
					{
						width: 'auto',
						text: student.certificate.number,
						fontSize: 14,
						bold: true
					}
				]
			},
			{
				margin: [0, centimetersToPoints(2), 0, 0],
				layout: 'noBorders',
				lineHeight: 1.4,
				table: {
					widths: [centimetersToPoints(5.5), '*'],
					body: [
						['Vārds, uzvārds', {
							text: `${student.name} ${student.surname}`,
							bold: true
						}],
						['personas kods', {
							text: student.personalCode,
							bold: true
						}],
						['apguva', {
							text: `${program.titleWhat}\n(programmas kods ${program.contractNumber})`,
							bold: true
						}],
						['un pabeidza', {
							text: 'Rīgas Tālmācības vidusskolu',
							bold: true
						}],
						['ar šādām sekmēm:', '']
					]
				}
			},
			{
				margin: [0, centimetersToPoints(0.5), 0, 0],
				lineHeight: 1,
				table: {
					widths: ['*', '35%'],
					body: student.marks?.map(mark => ([mark.subject.title, `${mark.mark} (${MARK_WORDS[mark.mark]})`]))
				},
				layout: {
					hLineStyle: () => {
						return {
							dash: {
								length: 2,
								space: 3
							}
						};
					},
					hLineWidth: (i) => {
						if (i === 0) return 0;
						return 0.5;
					},
					hLineColor: () => {
						return '#ddd';
					},
					vLineWidth: () => {
						return 0;
					},
					paddingTop: () => {
						return 3;
					},
					paddingBottom: () => {
						return 3;
					},
					paddingLeft: () => {
						return 0;
					}
				}
			},
			{
				pageBreak: 'before',
				bold: true,
				text: 'Nokārtoja eksāmenus ar šādām sekmēm: -----------------'
			},
			{
				margin: [0, 25, 0, 25],
				bold: true,
				text: `Nokārtoja centralizētos eksāmenus un saņēma vispārējās pamatizglītības sertifikātus šādos mācību priekšmetos: ${finals.length ? '' : '-----------------'}`
			},

			// Finals
			finals.length ? {
				lineHeight: 1.1,
				table: {
					widths: ['40%', '*'],
					body: finals?.map(final => ([
						`sertifikāts nr. ${final.number}`,
						final.final?.title
					]))
				},
				layout: {
					hLineWidth: () => {
						return 0;
					},
					vLineWidth: () => {
						return 0;
					},
					paddingTop: () => {
						return 0;
					},
					paddingBottom: () => {
						return 0;
					},
					paddingLeft: () => {
						return 0;
					},
					paddingRight: () => {
						return 0;
					}
				}
			} : null,


			// Release reason
			released ? {
				lineHeight: 1.1,
				text: released.reason
			} : null,
		
			// Attendance
			{
				margin: [0, 25, 0, 0],
				columns: [
					{
						width: 'auto',
						bold: true,
						text: 'Piedalījās'
					},
					attendance ? {
						width: '*',
						text: ` ${attendance.for}`,
						preserveLeadingSpaces: true
					} : {
						width: '*',
						text: ' -----------------',
						preserveLeadingSpaces: true
					}, 
				]
			},

			// Award
			{
				margin: [0, 0, 0, 0],
				columns: [
					{
						width: 'auto',
						bold: true,
						text: 'Apbalvojumi'
					},
					award ? {
						width: '*',
						text: ` ${award.for}`,
						preserveLeadingSpaces: true
					} : {
						width: '*',
						text: ' -----------------',
						preserveLeadingSpaces: true
					}, 
				]
			},

			// Signatures
			{
				margin: [0, 25, 0, 0],
				layout: 'noBorders',
				lineHeight: 1.6,
				table: {
					widths: ['25%', '25%', '25%', '25%'],
					body: [
						['',
							'',
							'Direktors',
							// 'Direktora p.i.',
							{
								alignment: 'right',
								text: 'E. Grīnis'
								// text: 'I. Lazda'
							}]
					]
				}
			},
			{
				margin: [0, 20, 0, 0],
				layout: 'noBorders',
				lineHeight: 1.6,
				table: {
					widths: ['25%', '25%', '25%', '25%'],
					body: [
						['',
							'',
							'Pedagogi',
							{
								alignment: 'right',
								text: student.certificate.teacherOneName
							}],
						['',
							'',
							'',
							{
								alignment: 'right',
								text: student.certificate.teacherTwoName
							}],
					]
				}
			},

			// Stamp and date place
			{ 
				margin: [0, 40, 0, 0],
				text: 'Z.v.'
			},
			{
				text: `Izsniegts ${dayjs(student.certificate.issueDate).format('ll')}`
			}
		]
	};

	// Append vfs with custom config
	pdfMake.vfs = vfs;

	// Append custom fonts
	pdfMake.fonts = {
		Times: {
			normal: 'Times-Regular.ttf',
			bold: 'Times-Bold.ttf'
		}
	};

	// Download pdf
	if (parameters.action === 'download') pdfMake.createPdf(document).download(`izraksts-${student.name}-${student.surname}.pdf`);

	// Open print dialogue
	if (parameters.action === 'print') pdfMake.createPdf(document).getBase64(base64 => printJS({
		printable: base64,
		base64: true,
		type: 'pdf'
	}));
};